import React from 'react';

function Dispute() {
  return (
    <div className="terms-container">
      <h1>Disputarea Tranzacțiilor</h1>
      <div className="terms-content">
        <section>
          <h2>Procedura de Disputare a Tranzacțiilor Neautorizate</h2>
          <p>
            În cazul în care observați tranzacții neautorizate sau suspecte în contul dumneavoastră, 
            vă rugăm să urmați pașii de mai jos pentru a raporta și disputa aceste tranzacții.
          </p>
        </section>

        <section>
          <h2>Cum să Raportați o Tranzacție Neautorizată</h2>
          <p>
            1. Contactați-ne imediat la adresa de email: <a href="mailto:support@alephmedia.ro">support@alephmedia.ro</a><br/>
            2. Furnizați detaliile tranzacției suspectate (data, suma și orice alte informații relevante)<br/>
            3. Explicați de ce considerați că tranzacția este neautorizată
          </p>
        </section>

        <section>
          <h2>Termene și Proceduri</h2>
          <p>
            • Disputele trebuie raportate în termen de 60 de zile de la data tranzacției<br/>
            • Vom investiga fiecare caz în parte și vom răspunde în termen de maxim 10 zile lucrătoare<br/>
            • În cazuri complexe, investigația poate dura până la 45 de zile
          </p>
        </section>

        <section>
          <h2>Protecția Consumatorului</h2>
          <p>
            Conform legislației în vigoare, beneficiați de protecție împotriva tranzacțiilor neautorizate. 
            În cazul în care se dovedește că o tranzacție a fost într-adevăr neautorizată, veți primi 
            rambursarea completă a sumei respective.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Pentru asistență imediată sau informații suplimentare:<br/>
            • Email: support@alephmedia.ro<br/>
            • Telefon: +40 (740) 111 476<br/>
            • Program: Luni-Vineri, 9:00-17:00
          </p>
        </section>
      </div>
    </div>
  );
}

export default Dispute; 